export default "__VITE_ASSET__3a83ba5f__"